import React from 'react';
import { useIntl } from 'react-intl';

import { useStateFromProp } from '~hooks/common';

import Modal from '~components/modal';

import PhoneForm from './form';

const PhoneModal = ({ isOpened, onToggle = () => {}}) => {
  const intl = useIntl();
  const [isModalOpened, setModalOpen] = useStateFromProp(isOpened, onToggle);

  const handleSubmit = (params) => {
    setModalOpen(false);
  };

  return (
    <Modal.Wrapper isOpened={isModalOpened} onClose={() => setModalOpen()} className="c-modal--plain c-modal--narrow">
      <Modal.Content>
        <h2 className="l-headline--secondary c-modal__headline">
          {intl.formatMessage({ id: 'containers.account.phone.modal.headline', defaultMessage: 'Edit phone number' })}
        </h2>
        <PhoneForm onSubmit={handleSubmit} />
      </Modal.Content>
    </Modal.Wrapper>
  );
};

export default PhoneModal;
